var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-access-control-event-table',{attrs:{"select-config-name":['default'],"title":_vm.$t('global.models.access_control_event.heading'),"subtitle":_vm.$t('global.models.access_control_event.subheading')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }